import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import TextButton from './common/TextButton';
import { commonStyles } from '../styles/common';

const SimpleFooter: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Box
      component="footer"
      sx={{
        ...commonStyles.flexCenter,
        flexDirection: 'column',
        py: 3,
        mt: 'auto',
        borderTop: '1px solid',
        borderColor: 'divider',
        backgroundColor: 'background.paper',
      }}
    >
      <Box sx={{ ...commonStyles.flexCenter, gap: 2, mb: 2 }}>
        <TextButton to="/about">{t('navigation.about')}</TextButton>
        <TextButton to="/contact">{t('navigation.contact')}</TextButton>
        <TextButton to="/privacy-policy">{t('navigation.privacyPolicy')}</TextButton>
        <TextButton to="/terms-of-service">{t('navigation.termsOfService')}</TextButton>
      </Box>
      <Typography variant="body2" color="text.secondary">
        {t('footer.copyright')}
      </Typography>
    </Box>
  );
};

export default SimpleFooter; 